export const INITIAL_STATE = {
  data: null,
  nonProfitData: null,
  isLoading: false,
  error: null,
  nonProfitError: null,
};
